import { PropTypes } from "prop-types";

export const RailbarContainer = ({ id = "rail-bar-header" }) => (
  <div id={id}></div>
);

RailbarContainer.propTypes = {
  id: PropTypes.string,
};
